module.exports = __webpack_public_path__ + "img/虚拟主播.61412dd5.jpg";